import providers from './providers';

export const providerConfig  = {
    providers
};